<template>
  <div class="container-stocklisting">
    <div class="card-size-stocklisting" style="--elevation: 16">
      <v-img class="stocklisting-image mb-2" :src="imgURL" top alt="..." />
      <div class="title">{{ title }}</div>
      <div class="price">${{ price / 100 }}</div>
      <v-select
        v-model="size" 
        label="Size"
        :items="['X-Small', 'Small', 'Medium', 'Large', 'X-Large', 'XX-Large','XXX-Large']"
        v-on:change="emitSize()"
      ></v-select>
    </div>
  </div>
</template>

<script>
export default {
  props: ["imgURL", "title", "price"],
  data() {
    return {
      size: "None selected", //You are here-communicate this listing to parent view
    };
  },
  methods: {
    emitSize() {
      this.$emit('message',this.size)
    }
  },
};
</script>

<style>
.container-stocklisting {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  max-width: 450px;
}

.stocklisting-image {
  width: 400px;
  height: auto;
  object-fit: cover;
}

.card-size-stocklisting {
  width: 100%;
  margin-top: 2rem;
  margin-left: 2rem;
  margin-bottom: 2rem;
  margin-right: 2rem;
  padding: 2rem;
  --elevation: 0;
  --epx: calc(var(--elevation) * 1px);
  /* these 2 shadows serve as a border for  0-1 elevation    */
  --shadow1: 0 0 1px rgba(0, 0, 0, 0.1);
  --shadow2: 0 1px 2px rgba(0, 0, 0, 0.08);
  --offset-y: calc(var(--epx) + 1px);
  --blur: calc(var(--epx) * 2);
  --spread: calc(var(--epx) * 0.3);
  --shadow3: 0 var(--offset-y) var(--blur) var(--spread) rgba(0, 0, 0, 0.2);
  box-shadow: var(--shadow1), var(--shadow2), var(--shadow3);
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
}

.price {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
}
</style>
